<template>
	<div class="pa-5">

			<h3 class="font-weight-regular">Archivos multimedia</h3>

			<v-data-table
				:headers="encabezado"
      	:items="archivos.listado"
				:loading="archivos.inicializando"
				expand-icon="mdi-close"
				hide-default-footer
				class="elevation-1"
			>

				<template v-slot:body="{ items }">
					<tbody>
						<tr
							v-for="item in items"
							:key="item.identificador"
						>
							<td>
								<v-icon v-if="item.datos.tipo === 'imagen'">mdi-image</v-icon>
								<v-icon v-else-if="item.datos.tipo === 'audio'">mdi-volume-high</v-icon>
								<v-icon v-else-if="item.datos.tipo === 'video'">mdi-video</v-icon>
								<v-icon v-else-if="item.datos.mime === 'application/pdf'">mdi-pdf-box</v-icon>
								<v-icon v-else-if="item.datos.mime === 'text/plain'">mdi-text-box</v-icon>
								<v-icon v-else-if="item.datos.mime === 'application/msword' || item.datos.mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || item.datos.mime === 'application/vnd.oasis.opendocument.text' || item.datos.mime === 'application/x-abiword' || item.datos.mime === 'application/rtf'">mdi-file-word-box</v-icon>
								<v-icon v-else-if="item.datos.mime === 'application/vnd.ms-excel' || item.datos.mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || item.datos.mime === 'application/vnd.oasis.opendocument.spreadsheet'">mdi-file-excel-box</v-icon>
								<v-icon v-else-if="item.datos.mime === 'application/vnd.ms-powerpoint' || item.datos.mime === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || item.datos.mime === 'application/vnd.oasis.opendocument.presentation'">mdi-file-powerpoint-box</v-icon>
								<v-icon v-else-if="item.datos.mime === 'application/x-bzip' || item.datos.mime === 'application/x-bzip2' || item.datos.mime === 'application/x-rar-compressed' || item.datos.mime === 'application/x-rar-compressed' || item.datos.mime === 'application/x-tar' || item.datos.mime === 'application/zip' || item.datos.mime === 'application/x-7z-compressed'">mdi-zip-box</v-icon>
								<v-icon v-else>mdi-file</v-icon>
								&nbsp;&nbsp;
								<a :href="item.datos.ubicación" target="_blank">
									{{ nombreDeArchivoDesdeStorage(item.datos.ubicación) }}
								</a>
							</td>
							<td>
								<span v-if="item.datos.tipo === 'imagen'">Imagen</span>
								<span v-else-if="item.datos.tipo === 'audio'">Audio</span>
								<span v-else-if="item.datos.tipo === 'video'">Video</span>
								<span v-else>{{ item.datos.mime }}</span>
							</td>
							<td><span style="white-space: nowrap">{{ new Intl.NumberFormat('es').format(item.datos.peso) }} bytes</span></td>
							<td><span style="white-space: nowrap">{{ new Date(item.datos.fechaDeCreación.seconds * 1000).toLocaleString('es-CO') }}</span></td>
						</tr>
					</tbody>
				</template>

			</v-data-table>
	</div>
</template>

<script>

import { nombreDeArchivoDesdeStorage } from '@/utilidades.js'
import { archivos } from '@/fuentes.js'

export default {
  name: 'AdministracionArchivos',

  data: () => ({
		archivos: archivos,
		encabezado: [
			{ text: 'Archivo', sortable: false, },
			{ text: 'Tipo', sortable: false, },
			{ text: 'Peso', sortable: false, },
			{ text: 'Fecha de carga', sortable: false, },
		]
	}),

	mounted: function() {
		this.archivos.inicializar()
	},

	methods: {
		nombreDeArchivoDesdeStorage,
	}
};


</script>